// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
// import { IsNotEmpty } from "class-validator";
import { IsNotEmpty, IsPostalCode } from "class-validator";
// App
import { FamilyAddressDTO } from "Globals/Models/DTO/FamilyAddressDTO";

export class FamilyAddressModel extends ModelBase<FamilyAddressModel, FamilyAddressDTO> {
    @MobX.observable public id: string | null = null;

    @MobX.observable public personalDetailId: string = "";

    @IsNotEmpty({ message: "Address Line 1 is required" })
    @MobX.observable
    public addressLine1: string = "";

    @MobX.observable
    public addressLine2: string = "";

    @MobX.observable
    public addressLine3: string = "";

    @IsNotEmpty({ message: "City is required" })
    @MobX.observable
    public city: string = "";

    @IsNotEmpty({ message: "County is required" })
    @MobX.observable
    public county: string = "";

    @IsPostalCode("GB", { message: "Postcode is not a valid UK postcode" })
    @IsNotEmpty({ message: "Postcode is required" })
    @MobX.observable
    public postcode: string = "";

    @MobX.observable public createdDate: Date | null = null;

    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: FamilyAddressDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.personalDetailId = model.personalDetailId;
            this.addressLine1 = model.addressLine1;
            this.addressLine2 = model.addressLine2;
            this.addressLine3 = model.addressLine3;
            this.city = model.city;
            this.county = model.county;
            this.postcode = model.postcode;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): FamilyAddressDTO => {
        let model: FamilyAddressDTO = {
            id: this.id,
            personalDetailId: this.personalDetailId,
            addressLine1: this.addressLine1,
            addressLine2: this.addressLine2,
            addressLine3: this.addressLine3,
            city: this.city,
            county: this.county,
            postcode: this.postcode,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = "";
        this.personalDetailId = "";
        this.addressLine1 = "";
        this.addressLine2 = "";
        this.addressLine3 = "";
        this.city = "";
        this.county = "";
        this.postcode = "";
        this.createdDate = null;
        this.isDeleted = false;
    };
}
